module.exports = __webpack_public_path__ + "static/media/rightArrow.52ca2098.svg";